module.exports = __webpack_public_path__ + "static/media/Img-onboarding-tokens-01.a44a93de.png";